import { Component, OnInit, Inject, Optional, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { CustomizationStoreService } from 'src/services/customization.store.service';
import { TranslationService } from 'src/services/translation.service';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Subscription } from 'rxjs';

@Component({
  selector: 'belender-legal',
  templateUrl: './legal.component.html',
  styleUrls: ['./legal.component.scss']
})
export class LegalComponent implements OnInit, OnDestroy {
  legal;
  loading = false;
  funderStyles;
  funderConfig;

  closeLabel = {
    'es': 'Cerrar',
    'en': 'Close',
    'it': 'Vicino',
    'fr': 'Fermer',
    'ca': 'Tancar',
    'de': 'schließen',
    'pt': 'Fechar'
  };
  policy = null;
  sFunderStyles: Subscription;
  sFunderConfig: Subscription;
  sPolicy: Subscription;
  selectedLang = this.customizationStoreService.LANG;

  constructor(private cd: ChangeDetectorRef, private customizationStoreService: CustomizationStoreService, private translationService: TranslationService, @Optional() @Inject(MAT_DIALOG_DATA) public data: { lang: string | null, flow: string | null, allData: any | null }) {
    // set Customization data when CustomizationService request is completed

  }

  ngOnInit(): void {

      this.sFunderStyles = this.customizationStoreService.getFunderStyles().subscribe(
        (customization) => {
          if (customization && Object.keys(customization).length > 0) {
            this.funderStyles = customization;
          }
        },
      );

      this.sFunderConfig = this.customizationStoreService.getFunderConfig().subscribe(
        (config) => {
          if (config && Object.keys(config).length > 0) {
            this.funderConfig = config;
            this.setCustomization(this.funderConfig);
          }
        },
      );
  }

  ngOnDestroy(): void {
    this.sFunderStyles && this.sFunderStyles.unsubscribe();
    this.sFunderConfig && this.sFunderConfig.unsubscribe();
    this.sPolicy && this.sPolicy.unsubscribe();
  }

  async getPolicy() {
    return new Promise((resolve) => {
      this.sPolicy = this.customizationStoreService.getPolicyTranslated().subscribe(
        (policy) => {
          resolve(policy)
        }, () => {resolve(null)}
      )
    })

  }

  isObjectEmpty(obj: any): boolean {
    return !obj || !Object.keys(obj) || Object.keys(obj).length === 0;
  }

  async setCustomization(config) {
    const policy = await this.getPolicy();
    if(!this.isObjectEmpty(policy)) {
      this.legal = policy;
    } else if(this.data && this.data.flow && this.data.allData && this.data.allData[this.data.flow] && this.data.allData[this.data.flow].texts && this.data.allData[this.data.flow].texts.policy) {
      this.legal = this.data.allData[this.data.flow].texts.policy;
    } else if(this.data && this.data.flow && this.data.allData && this.data.allData[this.data.flow] && this.data.allData[this.data.flow].config_translate && this.data.allData[this.data.flow].config_translate.policy) {
      this.legal = this.data.allData[this.data.flow].config_translate.policy;
    } else if(config && config.policy) {
      this.legal = config.policy;
    }
    this.loading = false;

  }
}
